@if (isDelegateTa()) {
<!--  ======== Delegate TA: the booking officer accepts on the traveller's behalf ========  -->
  <div class="w-full h-full flex flex-col gap-6">
    <div class="text-dialog-color text-base font-semibold font-['Inter'] leading-6 -mb-3">Delegate TA Authorisation</div>
<!--  para 1-->
    <div class="w-full flex flex-col gap-1">
      <div class="text-dialog-color text-base font-semibold font-['Inter'] leading-6">Purpose of Deduction</div>
      <div class="self-stretch justify-start pl-3">
        <span class="text-dialog-color text-sm font-normal font-['Inter'] leading-6">I, </span>
        <span class="text-dialog-color text-sm font-semibold font-['Inter'] leading-6">{{ bookingOfficerName() }}</span>
        <span class="text-dialog-color text-sm font-normal font-['Inter'] leading-6">, confirm that I am requesting a </span>
        <span class="text-dialog-color text-sm font-semibold font-['Inter'] leading-6">Travel Allowance (TA)</span>
        <span class="text-dialog-color text-sm font-normal font-['Inter'] leading-6"> pre-payment on behalf of this TA’s Primary Traveller, </span>
        <span class="text-dialog-color text-sm font-semibold font-['Inter'] leading-6">{{ travellerName() }}</span>
        <span class="text-dialog-color text-sm font-normal font-['Inter'] leading-6">. The pre-payment will be processed through the organisation’s approved </span>
        <span class="text-dialog-color text-sm font-semibold font-['Inter'] leading-6">TA Platform (TAP)</span><span class="text-dialog-color text-sm font-normal font-['Inter'] leading-6">.</span>
      </div>
      <div class="self-stretch justify-start pl-3">
        <span class="text-dialog-color text-sm font-normal font-['Inter'] leading-6">The Primary Traveller acknowledges that if:<br/></span>
        <ul class="list-disc list-inside pl-3">
          <li class="text-dialog-color text-sm font-normal font-['Inter'] leading-6">the travel does not occur in full, or is later modified/cancelled, or</li>
          <li class="text-dialog-color text-sm font-normal font-['Inter'] leading-6">the pre-payment exceeds the amount ultimately required or approved</li>
        </ul>
        <span class="text-dialog-color text-sm font-normal font-['Inter'] leading-6">and that, as a result, the Primary Traveller owes the employer the overpayment amount stated in this travel allowance application, they authorise the overpayment amount to be deducted from their wages/salary.</span>
      </div>
    </div>
<!--  para 2-->
    <div class="w-full flex flex-col gap-1">
      <div class="text-dialog-color text-base font-semibold font-['Inter'] leading-6">Repayment Method</div>
      <div class="self-stretch justify-start pl-3">
        <span class="text-dialog-color text-sm font-normal font-['Inter'] leading-6">The Primary Traveller acknowledges that any overpayment will be deducted from their wages/salary.</span>
      </div>
      <ta-toast title="Repayment Options - Debts Exceeding $200"
                body="If the overpayment debt is greater than $200, the Primary Traveller can request to repay it over 2 or more pay cycles. Please make this request using the Comments area when acquitting the TA."
                size="max"
                [closable]="false"
                severity="info"
      ></ta-toast>
    </div>
<!--  para 3-->
    <div class="w-full flex flex-col gap-1">
      <div class="text-dialog-color text-base font-semibold font-['Inter'] leading-6">Authorisation</div>
      <div class="flex gap-2">
        <div class="pl-3">
          <p-check-box size="small" [(ngModel)]="formData.authorisation" [binary]="true"></p-check-box>
        </div>
        <div class="self-stretch justify-start pl-2 pt-1">
          <span class="text-dialog-color text-sm font-normal font-['Inter'] leading-6">I, </span>
          <span class="text-dialog-color text-sm font-semibold font-['Inter'] leading-6">{{ bookingOfficerName() }}</span>
          <span class="text-dialog-color text-sm font-normal font-['Inter'] leading-6">, acting on behalf of the Primary Traveller, </span>
          <span class="text-dialog-color text-sm font-semibold font-['Inter'] leading-6">{{ travellerName() }}</span>
          <span class="text-dialog-color text-sm font-normal font-['Inter'] leading-6">, voluntarily authorise the employer to deduct any overpayment amount(s) from the Primary Traveller’s salary or wages in accordance with:<br/></span>
          <ul class="list-disc list-inside pl-3">
            <li class="text-dialog-color text-sm font-normal font-['Inter'] leading-6">Fair Work Act 2009 (Cth) and NT employment law.</li>
            <li class="text-dialog-color text-sm font-normal font-['Inter'] leading-6">The Primary Traveller’s individual contract of employment and internal policies.</li>
            <li class="text-dialog-color text-sm font-normal font-['Inter'] leading-6">This authorisation which I am providing when requesting the TA via the TAP.</li>
          </ul>
          <span class="text-dialog-color text-sm font-normal font-['Inter'] leading-6">I understand that:<br/></span>
          <ul class="list-disc list-inside pl-3">
            <li class="text-dialog-color text-sm font-normal font-['Inter'] leading-6">Deductions will appear clearly on the Primary Traveller’s pay slips.</li>
            <li class="text-dialog-color text-sm font-normal font-['Inter'] leading-6">This authorisation remains valid until the full overpayment amount is recovered, unless revoked in writing by the Primary Traveller or superseded by a new agreement.</li>
            <li class="text-dialog-color text-sm font-normal font-['Inter'] leading-6">No deductions will reduce the Primary Traveller’s pay below the minimum lawful entitlements.</li>
          </ul>
        </div>
      </div>

    </div>
<!--  para 4-->
    <div class="w-full flex flex-col gap-1">
      <div>
        <span class="text-dialog-color text-sm font-normal font-['Inter'] leading-6">Date of authorisation:  </span>
        <span class="text-dialog-color text-sm font-semibold font-['Inter'] leading-6"> {{formData.authorisationDate  | date:'dd/MM/yyyy'}} </span>
      </div>
      <div class="self-stretch justify-start">
        <span class="text-dialog-color text-sm font-normal font-['Inter'] leading-6">To provide authorisation, please tick the authorisation checkbox and select </span>
        <span class="text-dialog-color text-sm font-bold font-['Inter'] leading-6">Save</span>
        <span class="text-dialog-color text-sm font-normal font-['Inter'] leading-6">.</span>
      </div>

    </div>
    <div class="flex justify-end gap-2">
      <p-button size="small" label="Cancel" severity="secondary" (click)="closeDialog(null)" />
      <p-button size="small" label="Save" (click)="closeDialog(formData)" [disabled]="!formData.authorisation" />
    </div>
  </div>
} @else {
<!--  ======== Standard TA: the traveller accepts for themselves ========  -->
  <div class="w-full h-full flex flex-col gap-6">
<!--  para 1-->
    <div class="w-full flex flex-col gap-1">
      <div class="text-dialog-color text-base font-semibold font-['Inter'] leading-6">Purpose of Deduction</div>
      <div class="self-stretch justify-start pl-3">
        <span class="text-dialog-color text-sm font-normal font-['Inter'] leading-6">I, {{ travellerName() }}, confirm that I am requesting a </span>
        <span class="text-dialog-color text-sm font-semibold font-['Inter'] leading-6">Travel Allowance (TA)</span>
        <span class="text-dialog-color text-sm font-normal font-['Inter'] leading-6"> pre-payment, which will be processed through the organisation’s approved </span>
        <span class="text-dialog-color text-sm font-semibold font-['Inter'] leading-6">TA platform (TAP)</span><span class="text-dialog-color text-sm font-normal font-['Inter'] leading-6">.</span>
      </div>
      <div class="self-stretch justify-start pl-3">
        <span class="text-dialog-color text-sm font-normal font-['Inter'] leading-6">I acknowledge that if:<br/></span>
        <ul class="list-disc list-inside pl-3">
          <li class="text-dialog-color text-sm font-normal font-['Inter'] leading-6">the travel does not occur in full, or is later modified/cancelled, or</li>
          <li class="text-dialog-color text-sm font-normal font-['Inter'] leading-6">the pre-payment exceeds the amount ultimately required or approved</li>
        </ul>
        <span class="text-dialog-color text-sm font-normal font-['Inter'] leading-6">and that, as a result, I owe the employer the overpayment amount stated in this travel allowance application, I authorise the overpayment amount to be deducted from my wages/salary.</span>
      </div>
    </div>
<!--  para 2-->
    <div class="w-full flex flex-col gap-1">
      <div class="text-dialog-color text-base font-semibold font-['Inter'] leading-6">Repayment Method</div>
      <div class="self-stretch justify-start pl-3">
        <span class="text-dialog-color text-sm font-normal font-['Inter'] leading-6">I acknowledge that any overpayment will be deducted from my wages/salary.</span>
      </div>
      <ta-toast title="Repayment Options - Debts Exceeding $200"
                body="If the overpayment debt is greater than $200, you can request to repay it over 2 or more pay cycles. Please make this request using the Comments area when acquitting your TA."
                size="max"
                [closable]="false"
                severity="info"
      ></ta-toast>
    </div>
<!--  para 3-->
    <div class="w-full flex flex-col gap-1">
      <div class="text-dialog-color text-base font-semibold font-['Inter'] leading-6">Authorisation</div>
      <div class="flex gap-2">
        <div class="pl-3">
          <p-check-box size="small" [(ngModel)]="formData.authorisation" [binary]="true"></p-check-box>
        </div>
        <div class="self-stretch justify-start pl-2 pt-1">
          <span class="text-dialog-color text-sm font-normal font-['Inter'] leading-6">I voluntarily authorise my employer to deduct any overpayment amount(s) from my salary or wages in accordance with:<br/></span>
          <ul class="list-disc list-inside pl-3">
            <li class="text-dialog-color text-sm font-normal font-['Inter'] leading-6">Fair Work Act 2009 (Cth) and NT employment law.</li>
            <li class="text-dialog-color text-sm font-normal font-['Inter'] leading-6">My individual contract of employment and internal policies.</li>
            <li class="text-dialog-color text-sm font-normal font-['Inter'] leading-6">This authorisation which I am providing when requesting the TA via the TAP.</li>
          </ul>
          <span class="text-dialog-color text-sm font-normal font-['Inter'] leading-6">I understand that:<br/></span>
          <ul class="list-disc list-inside pl-3">
            <li class="text-dialog-color text-sm font-normal font-['Inter'] leading-6">Deductions will appear clearly on my pay slips.</li>
            <li class="text-dialog-color text-sm font-normal font-['Inter'] leading-6">This authorisation remains valid until the full overpayment amount is recovered, unless revoked in writing by me or superseded by a new agreement.</li>
            <li class="text-dialog-color text-sm font-normal font-['Inter'] leading-6">No deductions will reduce my pay below the minimum lawful entitlements.</li>
          </ul>
        </div>
      </div>

    </div>
<!--  para 4-->
    <div class="w-full flex flex-col gap-1">
      <div>
        <span class="text-dialog-color text-sm font-normal font-['Inter'] leading-6">Date of authorisation:  </span>
        <span class="text-dialog-color text-sm font-semibold font-['Inter'] leading-6"> {{formData.authorisationDate  | date:'dd/MM/yyyy'}} </span>
      </div>
      <div class="self-stretch justify-start">
        <span class="text-dialog-color text-sm font-normal font-['Inter'] leading-6">To provide authorisation, please tick the authorisation checkbox and select </span>
        <span class="text-dialog-color text-sm font-bold font-['Inter'] leading-6">Save</span>
        <span class="text-dialog-color text-sm font-normal font-['Inter'] leading-6">.</span>
      </div>

    </div>
    <div class="flex justify-end gap-2">
      <p-button size="small" label="Cancel" severity="secondary" (click)="closeDialog(null)" />
      <p-button size="small" label="Save" (click)="closeDialog(formData)" [disabled]="!formData.authorisation" />
    </div>
  </div>
}